module.exports = __webpack_public_path__ + "static/manna-web-81d5871153a029b990d2d9348ba86fd0.jpg";